/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Value1Inputs */

const id_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai`)
};

const ms_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai`)
};

const da_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Værdi`)
};

const de_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert`)
};

const en_us2_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const es_es2_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const es_mx2_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const fil_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaga`)
};

const fr_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur`)
};

const it_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore`)
};

const hu_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érték`)
};

const nl_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarde`)
};

const no_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdi`)
};

const pl_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartość`)
};

const pt_br2_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const pt_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const ro_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoare`)
};

const fi_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvo`)
};

const sv_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Värde`)
};

const vi_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị`)
};

const tr_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değer`)
};

const cs_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota`)
};

const bg_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стойност`)
};

const ru_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значение`)
};

const uk_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значення`)
};

const ar_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القيمة`)
};

const hi_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मान`)
};

const th_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค่า`)
};

const ja_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値`)
};

const zh_cn2_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数值`)
};

const zh_hant1_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`數值`)
};

const ko_offerdetail_table_value1 = /** @type {(inputs: Offerdetail_Table_Value1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Offerdetail_Table_Value1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_value1 = /** @type {((inputs?: Offerdetail_Table_Value1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Value1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_value1(inputs)
	if (locale === "ms") return ms_offerdetail_table_value1(inputs)
	if (locale === "da") return da_offerdetail_table_value1(inputs)
	if (locale === "de") return de_offerdetail_table_value1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_value1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_value1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_value1(inputs)
	if (locale === "fil") return fil_offerdetail_table_value1(inputs)
	if (locale === "fr") return fr_offerdetail_table_value1(inputs)
	if (locale === "it") return it_offerdetail_table_value1(inputs)
	if (locale === "hu") return hu_offerdetail_table_value1(inputs)
	if (locale === "nl") return nl_offerdetail_table_value1(inputs)
	if (locale === "no") return no_offerdetail_table_value1(inputs)
	if (locale === "pl") return pl_offerdetail_table_value1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_value1(inputs)
	if (locale === "pt") return pt_offerdetail_table_value1(inputs)
	if (locale === "ro") return ro_offerdetail_table_value1(inputs)
	if (locale === "fi") return fi_offerdetail_table_value1(inputs)
	if (locale === "sv") return sv_offerdetail_table_value1(inputs)
	if (locale === "vi") return vi_offerdetail_table_value1(inputs)
	if (locale === "tr") return tr_offerdetail_table_value1(inputs)
	if (locale === "cs") return cs_offerdetail_table_value1(inputs)
	if (locale === "bg") return bg_offerdetail_table_value1(inputs)
	if (locale === "ru") return ru_offerdetail_table_value1(inputs)
	if (locale === "uk") return uk_offerdetail_table_value1(inputs)
	if (locale === "ar") return ar_offerdetail_table_value1(inputs)
	if (locale === "hi") return hi_offerdetail_table_value1(inputs)
	if (locale === "th") return th_offerdetail_table_value1(inputs)
	if (locale === "ja") return ja_offerdetail_table_value1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_value1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_value1(inputs)
	return ko_offerdetail_table_value1(inputs)
});
export { offerdetail_table_value1 as "offerDetail.table.value" }